(function () {
  'use strict';
  if (window.KinsoraHoverImages || !window.matchMedia) return;

  var selector = 'img[data-ks-hover-src]';
  var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var observed = new WeakSet();
  var intersection = null;
  var root = null;

  function hydrate(image) {
    if (!hover.matches || !image || !image.hasAttribute('data-ks-hover-src')) return;
    var src = image.getAttribute('data-ks-hover-src');
    var srcset = image.getAttribute('data-ks-hover-srcset');
    var loadToken = 0;
    function hasRealImage() {
      var current = image.currentSrc || image.getAttribute('src') || '';
      return image.complete && image.naturalWidth > 0 && current.indexOf('data:') !== 0;
    }
    function failed() {
      loadToken++;
      image.style.opacity = '0';
      image.classList.remove('is-image-ready');
    }
    function loaded() {
      if (!hasRealImage()) return;
      var token = ++loadToken;
      function ready() {
        if (token !== loadToken || !hasRealImage()) return;
        image.classList.add('is-image-ready');
        image.style.removeProperty('opacity');
      }
      function decodeFailed() { if (token === loadToken) failed(); }
      if (typeof image.decode !== 'function') { ready(); return; }
      try { image.decode().then(ready, decodeFailed); }
      catch (error) { decodeFailed(); }
    }
    // Inline opacity wins over both search and recommendation hover rules.
    // The primary image remains underneath until this image is ready.
    image.style.opacity = '0';
    image.addEventListener('load', loaded);
    image.addEventListener('error', failed);
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', src);
    image.removeAttribute('data-ks-hover-src');
    image.removeAttribute('data-ks-hover-srcset');
    if (intersection) intersection.unobserve(image);
    if (hasRealImage()) loaded();
  }

  function observeImage(image) {
    if (!hover.matches || observed.has(image) || !intersection) return;
    observed.add(image);
    intersection.observe(image);
  }

  function scan(node) {
    if (!hover.matches || !node || node.nodeType !== 1) return;
    if (node.matches(selector)) observeImage(node);
    var images = node.querySelectorAll(selector);
    for (var i = 0; i < images.length; i++) observeImage(images[i]);
  }

  function configure() {
    if (intersection) intersection.disconnect();
    intersection = null;
    observed = new WeakSet();
    var saveData = navigator.connection && navigator.connection.saveData;
    if (hover.matches && !saveData && 'IntersectionObserver' in window) {
      intersection = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hydrate(entry.target);
        });
      }, { rootMargin: '150px 0px' });
      scan(root);
    }
  }

  function onIntent(event) {
    if (!hover.matches || !event.target || !event.target.closest) return;
    var card = event.target.closest('.fc-card');
    if (card) hydrate(card.querySelector(selector));
  }

  function boot() {
    root = document.body;
    if (!root) return;
    configure();
    root.addEventListener('pointerover', onIntent, { passive: true });
    root.addEventListener('focusin', onIntent);
    if (hover.addEventListener) hover.addEventListener('change', configure);
    else if (hover.addListener) hover.addListener(configure);

    // Section responses and theme-editor insertions can add cards after boot.
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        if (!hover.matches || !intersection) return;
        records.forEach(function (record) {
          for (var i = 0; i < record.addedNodes.length; i++) scan(record.addedNodes[i]);
        });
      }).observe(root, { childList: true, subtree: true });
    }
  }

  window.KinsoraHoverImages = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
